import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationENLogin from 'locales/en/login/translation.json';
import translationFALogin from 'locales/fa/login/translation.json';
import translationENPDP from 'locales/en/pdp/translation.json';
import translationFAPDP from 'locales/fa/pdp/translation.json';
import translationENConfig from 'locales/en/config/translation.json';
import translationFAConfig from 'locales/fa/config/translation.json';
import translationENModals from 'locales/en/modals/translation.json';
import translationFAModals from 'locales/fa/modals/translation.json';
import translationENSurvey from 'locales/en/survey/translation.json';
import translationFASurvey from 'locales/fa/survey/translation.json';
import translationENGeneral from 'locales/en/general/translation.json';
import translationFAGeneral from 'locales/fa/general/translation.json';
import translationENMainNavBar from 'locales/en/mainNavBar/translation.json';
import translationFAMainNavBar from 'locales/fa/mainNavBar/translation.json';
import translationENTaskManager from 'locales/en/taskManager/translation.json';
import translationFATaskManager from 'locales/fa/taskManager/translation.json';
import translationENDocManager from 'locales/en/documentManager/translation.json';
import translationFADocManager from 'locales/fa/documentManager/translation.json';
import translationENCompanyManagement from 'locales/en/companyManagement/translation.json';
import translationFACompanyManagement from 'locales/fa/companyManagement/translation.json';
import translationENDialects from 'locales/en/dialects/translation.json';
import translationFADialects from 'locales/fa/dialects/translation.json';
import translationENProfile from 'locales/en/profile/translation.json';
import translationFAProfile from 'locales/fa/profile/translation.json';
import translationENChatBot from 'locales/en/chatbot/translation.json';
import translationFAChatBot from 'locales/fa/chatbot/translation.json';
import translationENLandingPage from 'locales/en/landingPage/translation.json';
import translationFALandingPage from 'locales/fa/landingPage/translation.json';

import {
  getDefaultTimeZoneLang,
  getLanguageBaseOnTZ,
} from './utils/LanguageLocalStorage';
import { ILocal } from './components/Chart/BaseDatePicker';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        login: translationENLogin,
        config: translationENConfig,
        translationENPDP: translationENConfig,
        pdp: translationENPDP,
        mainNavBar: translationENMainNavBar,
        documentManager: translationENDocManager,
        modals: translationENModals,
        survey: translationENSurvey,
        taskManager: translationENTaskManager,
        general: translationENGeneral,
        companyManagement: translationENCompanyManagement,
        dialects: translationENDialects,
        profile: translationENProfile,
        chatbot: translationENChatBot,
        landingPage: translationENLandingPage,
      },
      fa: {
        login: translationFALogin,
        config: translationFAConfig,
        pdp: translationFAPDP,
        mainNavBar: translationFAMainNavBar,
        documentManager: translationFADocManager,
        modals: translationFAModals,
        survey: translationFASurvey,
        taskManager: translationFATaskManager,
        general: translationFAGeneral,
        companyManagement: translationFACompanyManagement,
        dialects: translationFADialects,
        profile: translationFAProfile,
        chatbot: translationFAChatBot,
        landingPage: translationFALandingPage,
      },
    },
    supportedLngs: ['en', 'fa'],
    lng: getLanguageBaseOnTZ(),
    ns: [
      'login',
      'config',
      'mainNavBar',
      'documentManager',
      'modals',
      'survey',
      'taskManager',
      'companyManagement',
      'dialects',
      'chatbot',
      'landingPage',
      'pdp',
    ],
    defaultNS: 'login',
    interpolation: {
      escapeValue: false,
    },
    nsSeparator: false,
  });

type LocalList = 'fa_IR@calendar=persian' | 'en';
export type LanguageList = 'fa' | 'en' | 'ar';

export const languageDirection = (): 'ltr' | 'rtl' => {
  const rtlLanguages = ['fa', 'ar'];
  return rtlLanguages.includes(i18n.language) ? 'rtl' : 'ltr';
};

export const getCalendarLocal: () => ILocal = () => {
  return getDefaultTimeZoneLang() === 'fa' ? 'fa_IR@calendar=persian' : 'en';
};

export const getLocalDirection = (
  lang: LocalList = 'fa_IR@calendar=persian'
) => {
  switch (lang) {
    case 'en':
      return 'ltr';
    case 'fa_IR@calendar=persian':
      return 'rtl';
    default:
      return 'rtl';
  }
};

export const getLangBaseOnLocal = (local: ILocal) => {
  switch (local) {
    case 'fa_IR@calendar=persian':
      return 'fa';
    case 'en':
      return 'en';
    default:
      return 'fa';
  }
};

export const getLocalBaseOnLang = (lang: LanguageList) => {
  switch (lang) {
    case 'en':
      return 'en';
    case 'fa':
      return 'fa_IR@calendar=persian';
    default:
      return 'fa_IR@calendar=persian';
  }
};

export const localList = ['fa_IR@calendar=persian', 'en'];

export const rightLanguageList = ['fa', 'ar'];

export default i18n;
